import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router';

import { useAuth } from '../auth.jsx';
import { Loading } from '../components/ui.jsx';
import { ClientDashboard } from './Dashboards.jsx';

const Landing = lazy(() => import('./Landing.jsx').then((m) => ({ default: m.Landing })));

/**
 * What / shows: a signed-in client's dashboard; for everyone else the home page (Landing.jsx), or
 * the store when the admin has turned the home page off (ordering.landing_page, sent in bootstrap).
 */
export function Home() {
  const { me, loading, branding } = useAuth();
  if (loading) return <Loading />;
  if (me?.client) return <ClientDashboard />;
  if (branding?.landing_page === false) return <Navigate to="/store" replace />;
  return (
    <Suspense fallback={<Loading />}>
      <Landing />
    </Suspense>
  );
}
